import script from "./Inhalt.vue?vue&type=script&setup=true&lang=js"
export * from "./Inhalt.vue?vue&type=script&setup=true&lang=js"

import "./Inhalt.vue?vue&type=style&index=0&id=f3b8bfa8&scoped=true&lang=scss"

import exportComponent from "/Users/andrea/Dropbox/espresso/nx01/pcspezi.com/mbiza/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3b8bfa8"]])

export default __exports__